module.exports = __webpack_public_path__ + "media/images/flags/bl-75b2c7e5eb4ff1a0fb5995442e04cd74.svg";